import { operatorClient, shippingClient } from 'domain/HttpClients';
import { chunkArray } from 'domain/utils';

export const assign = (filters) => operatorClient
  .Post('/api/shipments/assign-by-filter')
  .withParams(filters)
  .withData({})
  .send();
export const downloadShippingLabels = async (shipmentsIds) => {
  const results = [];
  const array = chunkArray(shipmentsIds, 20);
  for (const chunk of array) {
    try {
      const response = await shippingClient
        .Get('/api/shipments/get-shipments-label-link')
        .withParams({ 'shipment-ids': chunk.join(',') })
        .send();
      results.push(response);
    } catch (e) {
      console.error(e);
    }
  }
  return results;
};

export const getAvailableResources = (at) => operatorClient
  .Get('/api/fleets/management/get-vehicles-summary')
  .withParams({
    at,
  })
  .send();

export const getAvailableResourceInfo = (vid) => operatorClient
  .Get('/api/fleets/management/get-summary-data')
  .withParams({
    vid,
  })
  .send();

export const getDropoffCities = async () => {
  try {
    const response = await operatorClient
      .Post(`/api/shipments/dropoff-cities?domain=${SYSTEM_DOMAIN}`)
      .send();
    return response;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getPickupCities = async () => {
  try {
    const response = await operatorClient
      .Get(`/api/shipments/pickup-cities?domain=${SYSTEM_DOMAIN}`)
      .send();
    return response;
  } catch (e) {
    console.error(e);
    return [];
  }
};
export const getCouriers = async (key) => {
  try {
    const response = await operatorClient
      .Get('api/accounts')
      .withParams({ name: key, type: 'COURIER' })
      .send();
    const output = response.results.map((row) => ({
      value: row.key,
      label: row.value.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getShippers = async (key) => {
  try {
    const response = await operatorClient
      .Get('api/shippers')
      .withParams({ did: SYSTEM_DOMAIN, firstName: key })
      .send();
    const output = response.results.map((row) => ({
      value: row.id,
      label: row.name,
      subLabel: row.company,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};
